import styled from 'styled-components'

export const StyledNewsSearchViewAll = styled.div``
